import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/ellipse_left.png";
import { StaticImage } from "gatsby-plugin-image";

const Timecmore = () => {
  return (
    <div
      className="time_cmore p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container>
        <Row>
          <div className="time_head text-center">
            <h2>
              Project <span>Timeline</span>
            </h2>
          </div>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="my-auto">
            <div className="time_main">
              <h5>Research</h5>
              <p>
                We have identified what the target audience needs and what
                functions and features of the application they expect.
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="my-auto">
            <div className="time_main">
              <h5>UX Design</h5>
              <p>
                We have achieved an optimal combination of functionality, ease
                of use, and aesthetic design of the application.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="my-auto">
            <div className="time_main">
              <h5>UI Design</h5>
              <p>
                We have achieved a visually appealing and intuitively
                understandable user interface of the application
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="my-auto">
            <div className="time_main">
              <h5>Development</h5>
              <p>
                We conducted testing to identify and fix any possible errors and
                issues in our mobile application
              </p>
            </div>
          </Col>
        </Row>

        <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
          <div className="timeline_img">
            <StaticImage
              src="../../../images/case-studies/cmore/timeline.png"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={1181}
            />
          </div>
        </Col>
      </Container>
    </div>
  );
};

export default Timecmore;
